module.exports = __webpack_public_path__ + "static/how-it-works3-32577d734634119dcc8112e1069efda7.png";